import localstorage from './module/localstorage';
import clickListener from './module/clickListener';
import controllerSlider from './module/controllerSlider';
import lazyLoad from './module/lazyLoad';
import textareaResize from './module/textareaResize';
import polyfill from './module/polyfill';
import controllerReveal from './module/controllerReveal';
import calendar from './module/calendar';
import datePicker from './module/datePicker';

(function () {
    'use strict'

    polyfill();

    // localstorage(window, document);

    window.addEventListener('load', () => {
        lazyLoad();
        clickListener();
        textareaResize();
        calendar();
        datePicker();

        let sliderLs = document.querySelectorAll('.slider');
        if(sliderLs.length > 0){
            sliderLs.forEach((slider)=> {
                controllerSlider(slider)
            });
        }

        let revealLs = document.querySelectorAll('.target-reveal');
        if(revealLs.length > 0){
            controllerReveal(revealLs);
        }
    })
})()